import React, { useState } from "react";
import "./Filter.scss";
import Circle from "../../assets/images/circle.svg";
import Yellowcircle from "../../assets/images/yellowcircle.svg";
import CheckBtn from "../CheckBtn";
function Filter() {
  const [modalShow, setModalShow] = React.useState(false);

  const [sampletestname, setSampletestname] = useState([
    { testname: "Blood", imgsrc: Circle },
    { testname: "Saliva", imgsrc: Circle },
    { testname: "Urine", imgsrc: Circle },
    { testname: "Stool", imgsrc: Circle },
  ]);

  const [price, setPrice] = useState([
    { pricename: "Highest to Lowest", imgsrc: Circle },
    { pricename: "Lowest to Highest", imgsrc: Circle },
  ]);

  const [range, setRange] = useState([
    { rangename: "A-E", imgsrc: Circle },
    { rangename: "F-J", imgsrc: Circle },
    { rangename: "I-O", imgsrc: Circle },
    { rangename: "P-T", imgsrc: Circle },
    { rangename: "U-Z", imgsrc: Circle },
  ]);

  const [selected, setselected] = useState([]);
  const [selectedprice, setselectedprice] = useState([]);
  const [selectedrange, setselectedrange] = useState([]);
  //   console.log("selected", selected);
  //   console.log("selectedprice", selectedprice);
  //   console.log("selectedrange", selectedrange);
  const handleRadiobutton = (v, ind) => {
    const idToRemove = v.testname;
    if (selected.includes(v.testname)) {
      const filteredvalues = selected.filter((item) => item !== v.testname);
      setselected(filteredvalues);
    } else {
      setselected([v.testname]);
    }

    // console.log("hi", v, ind);
  };

  const handleRadiobuttonprice = (v, ind) => {
    const idToRemove = v.pricename;
    if (selectedprice.includes(v.pricename)) {
      const filteredvalues = selectedprice.filter(
        (item) => item !== v.pricename
      );
      setselectedprice(filteredvalues);
    } else {
      setselectedprice([v.pricename]);
    }

    // console.log("selectedprice", v, ind);
  };

  const handleRadiobuttonrange = (v, ind) => {
    const idToRemove = v.rangename;
    if (selectedrange.includes(v.rangename)) {
      const filteredvalues = selectedrange.filter(
        (item) => item !== v.rangename
      );
      setselectedrange(filteredvalues);
    } else {
      setselectedrange([v.rangename]);
    }

    // console.log("selectedrange", v, ind);
  };
  const clearfunction = () => {
    setselected([]);
    setselectedprice([]);
    setselectedrange([]);
  };
  const applyfunction = () => {
    console.log("filtervalues", {
      sample: selected[0],
      price: selectedprice[0],
      range: selectedrange[0],
    });
  };
  return (
    <div className="samplemain">
      <div
        className="price"
        style={{ marginTop: "20px", marginBottom: "16px" }}
      >
        Prices
      </div>

      <div className="pricenameparent">
        {price.map((v, ind) => {
          return (
            <>
              {selectedprice.includes(v.pricename) ? (
                <div className="pricename">
                  <img
                    className="backyellow"
                    src={Yellowcircle}
                    key={ind}
                    alt="circle"
                    onClick={() => handleRadiobuttonprice(v, ind)}
                  />
                  <span>{v.pricename}</span>
                </div>
              ) : (
                <div className="pricename2">
                  <img
                    className="backyellow"
                    src={Circle}
                    key={ind}
                    alt="circle"
                    onClick={() => handleRadiobuttonprice(v, ind)}
                  />
                  <span>{v.pricename}</span>
                </div>
              )}
            </>
          );
        })}
      </div>

      <div
        className="Range"
        style={{ marginTop: "20px", marginBottom: "16px" }}
      >
        Range
      </div>

      <div className="sampletestnameparent">
        {range.map((v, ind) => {
          return (
            <>
              {selectedrange.includes(v.rangename) ? (
                <div className="sampletestname" style={{ width: "89px" }}>
                  <img
                    className="backyellow"
                    src={Yellowcircle}
                    key={ind}
                    alt="circle"
                    onClick={() => handleRadiobuttonrange(v, ind)}
                  />
                  <span>{v.rangename}</span>
                </div>
              ) : (
                <div className="sampletestname2" style={{ width: "89px" }}>
                  <img
                    className="backyellow"
                    src={Circle}
                    key={ind}
                    alt="circle"
                    onClick={() => handleRadiobuttonrange(v, ind)}
                  />
                  <span>{v.rangename}</span>
                </div>
              )}
            </>
          );
        })}
      </div>

      <div className="footbuttons">
        <button className="cls" onClick={() => clearfunction()}>
          Clear
        </button>
        <button className="applyfil" onClick={() => applyfunction()}>
          Apply Filter
        </button>
      </div>
    </div>
  );
}

export default Filter;
